module.exports = __webpack_public_path__ + "static/media/stranger-things@2x.b8164509.jpg";


//////////////////
// WEBPACK FOOTER
// /src/images/stranger-things@2x.jpg
// module id = 428
// module chunks = 1